
const digest = '4ce0a86acaaa4405e9ec0cdc7294b556d7037414ead5a94645859b07eb9ff7d7';
const classes = {"wrapper":"_wrapper_1x344_1","header":"_header_1x344_5","titleWrapper":"_titleWrapper_1x344_16","icon":"_icon_1x344_22","title":"_title_1x344_16","button":"_button_1x344_31","buttonHide":"_buttonHide_1x344_31","buttonShow":"_buttonShow_1x344_31","content":"_content_1x344_46","contentPadding":"_contentPadding_1x344_50"};
const css = `._wrapper_1x344_1 {
  font-family: Rubik, "sans-serif";
}

._header_1x344_5 {
  border-left: 4px solid #1665d8;
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  justify-content: space-between;
  padding: 24px;
  border-top: 1px solid #eaedf3;
  border-bottom: 1px solid #eaedf3;
  cursor: pointer;
}
._header_1x344_5 ._titleWrapper_1x344_16 {
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
}
._header_1x344_5 ._icon_1x344_22 {
  min-width: 16px;
  max-width: 16px;
}
._header_1x344_5 ._title_1x344_16 {
  font-size: 14px;
  font-weight: 500;
  color: #000000;
}
._header_1x344_5 ._button_1x344_31, ._header_1x344_5 ._buttonHide_1x344_31, ._header_1x344_5 ._buttonShow_1x344_31 {
  font-size: 14px;
  color: #1665d8;
  text-decoration: underline;
  padding-right: 20px;
  display: flex;
  align-items: center;
}
._header_1x344_5 ._buttonShow_1x344_31 {
  background: url("/dist/icons/react/chevron-down.svg") no-repeat center right;
}
._header_1x344_5 ._buttonHide_1x344_31 {
  background: url("/dist/icons/react/chevron-up.svg") no-repeat center right;
}

._content_1x344_46 {
  background-color: #f8f8f8;
}

._contentPadding_1x344_50 {
  padding: 21px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  